import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
} from "@mui/material";

interface AddPatientDialogProps {
  open: boolean;
  canAddPatient: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const AddPatientDialog: React.FC<AddPatientDialogProps> = ({
  open,
  canAddPatient,
  onConfirm,
  onCancel,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      aria-labelledby="add-patient-dialog-title"
      aria-describedby="add-patient-dialog-description"
    >
      <DialogTitle id="add-patient-dialog-title">
        <Typography variant="h4">Add Patient</Typography>
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="add-patient-dialog-description">
          Are you sure you want to add a new patient? This will add a new
          patient record to the system.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} color="inherit" variant="outlined" fullWidth>
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          disabled={!canAddPatient}
          autoFocus
          fullWidth
        >
          Add Patient
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddPatientDialog;
